import React from "react";

const BackToHome = (props) => (
    <button type="button"
            className="back-to-home-button"
            style={{backgroundColor: "white", border: "none"}}
            onClick={props.onClick}>Back to Home</button>
);
BackToHome.propTypes = {
    onClick: React.PropTypes.func
};

export default BackToHome



/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/components/BackToHome.js
 **/